<template>
  <div class="main-container">
    <SubMenuHeader
      :title="$t('mapNavigation.title')"
      @onGoBack="back"
      @showVideo="$emit('showVideo')"
    />
    <div class="container--fluid m-0 p-0">
      <div class="row m-0">
        <div class="col p-0">
          <GmapMap
            ref="map"
            map-type-id="terrain"
            class="map"
            :center="myLocation"
            :zoom="7"
            :options="mapOptions"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import SubMenuHeader from '@/components/SubMenuHeader';
import { gmapApi } from 'vue2-google-maps';

import store from '../../store/store'
import getEnv from "@/utils/env";

export default {
  'name': 'MapNavigation',
  'components': { SubMenuHeader },
  data() {
    return {
      'myLocation': { 'lat': 0, 'lng': 0 },
      'lat': null,
      'lng': null,
      'address': null,
      'mapOptions': {
        'zoomControl': true,
        'mapTypeControl': false,
        'scaleControl': false,
        'streetViewControl': false,
        'rotateControl': true,
        'fullscreenControl': true,
        'disableDefaultUI': false
      }
    }
  },
  'methods': {
    async showDirection() {
      await this.updateLocation();
      this.$refs.map.$mapPromise.then((map) => {
        const directionService = new this.google.maps.DirectionsService();
        const directionRenderer = new this.google.maps.DirectionsRenderer();

        directionRenderer.setMap(map);

        const route = {
          'origin': new this.google.maps.LatLng(this.myLocation),
          'destination': this.createDestination(),
          'travelMode': this.google.maps.TravelMode.DRIVING
        };

        directionService.route(route, (result, callStatus) => {
          if (callStatus === 'OK') {
            directionRenderer.setDirections(result);
          } else if (callStatus === 'NOT_FOUND') {
            this.showMapMessage(this.$t('mapNavigation.errors.dirNotFound'));
          } else if (callStatus === 'ZERO_RESULTS') {
            this.showMapMessage(this.$t('mapNavigation.errors.dirZeroResults'));
          } else if (callStatus === 'MAX_ROUTE_LENGTH_EXCEEDED') {
            this.showMapMessage(this.$t('mapNavigation.errors.dirMaxLengthExceeded'));
          }
        })
      });
    },
    createDestination() {
      if (this.lat && this.lng) {
        // lat and lng are better than address, it the props has this values, use it, otherwise use address
        return new this.google.maps.LatLng({ 'lat': this.lat, 'lng': this.lng });
      } else {
        return this.address;
      }
    },
    showMapMessage(message) {
      this.$refs.map.$mapPromise.then((map) => {
        const infoWindow = new this.google.maps.InfoWindow();
        infoWindow.setPosition(map.getCenter());
        infoWindow.setContent(message);
        infoWindow.open(map);
      });
    },
    async updateLocation() {
      return new Promise((resolve) => {
        if (getEnv('VUE_APP_LOCATION_DISABLED') !== 'true') {
          if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition((position) => {
              this.myLocation = {
                'lat': position.coords.latitude,
                'lng': position.coords.longitude
              };
              resolve();
            }, () => {
              // can't get current position
              this.showMapMessage(this.$t('mapNavigation.errors.noPosition'));
            });
          } else {
            // Browser doesn't support Geolocation
            this.showMapMessage(this.$t('mapNavigation.errors.noSupportGeolocation'));
          }
        } else {
          this.showMapMessage(this.$t('mapNavigation.errors.mapDisabled'));
        }
      })
    },
    back() {
      this.$router.back();
    }
  },
  'computed': {
    'google': gmapApi
  },
  created() {
    if (store.state.siteDetailsDirection.lat && store.state.siteDetailsDirection.lng) {
      this.lat = store.state.siteDetailsDirection.lat;
      this.lng = store.state.siteDetailsDirection.lng;
    } else {
      this.address = store.state.siteDetailsDirection.address;
    }
  },
  mounted() {
    this.showDirection();
  }
}
</script>

<style scoped>
.main-container {
  margin-top: 52px;
}
.map {
  left: 0;
  right: 0;
  top: 52px;
  bottom: 0;
  position: fixed;
}
</style>
